
const Aggiorna_lista_alunni_per_semaforo_esterno = (lista_alunni, lista_progetti) => {
    const axios = require('axios')
    console.log('YYYYYYYYYYYYYYYYYYYYY')
    let lista_aux_alunni = lista_alunni

    
    lista_aux_alunni.map((item1, index) => {
            item1.progetto_in_futuro = false;
    })
    

    const oggi = new Date();
    console.log(lista_aux_alunni)

    lista_progetti.map((item, index) => {
   
      const data_fine_progetto = new Date(item.data_fine);
   
      if ( data_fine_progetto > oggi) {
          console.log('DATA FUTURA')
          var foundIndex = lista_aux_alunni.findIndex(x => x._id == item.id_alunno._id);
          console.log('HHHHHHHOOOOOO ' + foundIndex)
          if (foundIndex>-1) {
          lista_aux_alunni[foundIndex].progetto_in_futuro = true;
        }
      }
    })

    var foundIndex = lista_aux_alunni.findIndex(x => x._id == lista_progetti[0].id_alunno);
    console.log('HHHHHHHOOOOOO ' + foundIndex)
    if (foundIndex>-1) {
    lista_aux_alunni[foundIndex].progetto_in_futuro = true;
    } 



    lista_aux_alunni.map((item, index) => {
        console.log('DATA BBBBBBBBB ' + item.progetto_in_futuro)
       
        const nuovo_stato_semaforo = {
              progetto_in_futuro: lista_aux_alunni[index].progetto_in_futuro 
        }
        axios.patch('/alunni/modifica_semaforo_progetti_futuri/' + item._id, nuovo_stato_semaforo)
        .then((res) => {
            console.log(res.data)
        }).catch((error) => {
            console.log(error)
        });
    })
    } 

exports.Aggiorna_lista_alunni_per_semaforo_esterno = Aggiorna_lista_alunni_per_semaforo_esterno;
